import { alpha } from '@mui/material'

export default {
  components: {
    MuiSelect: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          fontSize: '14px',
          width: '100%',
          '.Mui-focused': { borderColor: 'red' },
          '.MuiMenu-paper': {
            boxShadow: 'none',
            borderRadius: '0px',
          },
          '& ul': {
            border: `1.5px solid ${theme.palette.secondary['80']}`,
            borderRadius: '4px',
            borderTop: '0',
            color: theme.palette.secondary['100'],

            minHeight: 'auto',
            maxHeight: '110px',
            overflowY: 'auto',
            padding: '0',
            top: '0',
            left: '0',
            width: '100%',
            '& li': {
              borderRadius: '4px',
              display: 'block',
              fontSize: '0.875rem',
              lineHeight: '18px',
              textOverflow: 'ellipsis',
              overflowX: 'hidden',
              padding: '10px 16px',
              whiteSpace: 'nowrap',
              '&:hover': {
                backgroundColor: `${alpha(
                  theme.palette.secondary['100'],
                  0.1
                )}`,
                overflowX: 'hidden',
              },
            },
          },
        }),
      },
    },
    MuiContainer:{
      styleOverrides:{
        root: ({ ownerState, theme }) => ({
          display:'none',
          '&.MuiContainer-maxWidthLg':{
            maxWidth:"1250px"
          }
        })
      }
    }
  },
}
